import { render, staticRenderFns } from "./CardLoyalty.vue?vue&type=template&id=5bf72451&"
import script from "./CardLoyalty.vue?vue&type=script&lang=js&"
export * from "./CardLoyalty.vue?vue&type=script&lang=js&"
import style0 from "./CardLoyalty.vue?vue&type=style&index=0&id=5bf72451&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports